import { StoreActionType as Type } from '../../types';

const initialState: any = {
    country: JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.countryId,
};

export const countryReducer: any = (state: any = initialState, action: any) => {
    switch (action?.type) {
        case Type.SET_COUNTRY:
            return {
                ...state,
                country: action?.payload?.country,
            };

        default:
            return state;
    }
};
